import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import { LeadParagraph } from '../../components/LeadParagraph';
export const _frontmatter = {
  "title": "Getting Started",
  "order": 1
};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const PageContent = makeShortcode("PageContent");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

<PageContent componentName="getting_started" type="api_intro" mdxType="PageContent">
<LeadParagraph mdxType="LeadParagraph">
  Install the React Magma component library, and start using Cengage-themed,
  accessible components in your application.
</LeadParagraph>
<p>{`For more information, including information on contributing to React Magma and running the project locally, visit the `}<a parentName="p" {...{
          "href": "https://github.com/cengage/react-magma"
        }}>{`Github Repo`}</a>{`.`}</p>
<h2>{`Installation`}</h2>
<h3>{`Setup Requirements`}</h3>
<ol>
<li parentName="ol">{`Your project needs to be running `}<strong parentName="li">{`React v16.5`}</strong>{` or greater`}</li>
<li parentName="ol">{`Icons must be installed as a peer dependency`}</li>
</ol>
<h3>{`Install the Component Library`}</h3>
<p>{`Install the React Magma Component library with `}<inlineCode parentName="p">{`npm`}</inlineCode>{`.`}</p>
<pre><code parentName="pre" {...{
          "className": "language-sh",
          "metastring": "title noRender noCodeSandbox",
          "title": true,
          "noRender": true,
          "noCodeSandbox": true
        }}>{`npm install --save react-magma-dom
`}</code></pre>
<p>{`Install peer dependencies`}</p>
<pre><code parentName="pre" {...{
          "className": "language-sh",
          "metastring": "title noRender noCodeSandbox",
          "title": true,
          "noRender": true,
          "noCodeSandbox": true
        }}>{`npm install --save \\
    "@emotion/core@10.0.35" \\
    "@emotion/styled@10.0.27" \\
    "date-fns@2.16.0" \\
    "downshift@5.4.7" \\
    "framer-motion@^4.1.11" \\
    "react@16.13.1" \\
    "react-dom@16.13.1" \\
    "react-magma-icons@1.0.2" \\
    "uuid@8.3.0"
`}</code></pre>
<h2>{`Icons Only`}</h2>
<p>{`The Icon library is not dependent on react-magma being used. `}<inlineCode parentName="p">{`react-magma-icons`}</inlineCode>{` can be used independently by installing the package as a dependency in your project.`}</p>
<pre><code parentName="pre" {...{
          "className": "language-sh",
          "metastring": "title noRender noCodeSandbox",
          "title": true,
          "noRender": true,
          "noCodeSandbox": true
        }}>{`npm install --save react-magma-icons
`}</code></pre>
<h2>{`Known Issues`}</h2>
<ol>
<li parentName="ol"><inlineCode parentName="li">{`Legacy context API has been detected within a strict-mode tree`}</inlineCode>{` - `}<a parentName="li" {...{
            "href": "https://github.com/JedWatson/react-select/pull/3487"
          }}>{`https://github.com/JedWatson/react-select/pull/3487`}</a></li>
</ol>
</PageContent>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      